<template>
    <div class="header">
        <el-col :span="3">
            <div class="layout-logo">
                <img :src="$store.getters.configList.logo" alt="" width="40" height="40">
            </div>
        </el-col>
        <el-col :span="16">
            <div class="menunav" style="font-size: 12px;">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                    background-color="#172636" text-color="#61688A" active-text-color="#ffd04b">
                    <!-- 首页 -->
                    <el-menu-item index="/">{{ $t("header.index") }}</el-menu-item>
                    <!-- 币币交易 -->
                    <!-- <el-menu-item index="/pages/trade/trade" v-if="configList.openCoin">{{ $t("header.exchange") }}</el-menu-item> -->
                    <el-menu-item index="/pages/trade/trade"  v-if="configList.openCoin">{{ $t("header.exchange") }}</el-menu-item>
                    <!-- 永续合约 -->
                    <el-menu-item index="/pages/contract/contract"  v-if="configList.openContract">{{ $t("header.swap1") }}</el-menu-item>
                    <!-- 期权合约 -->
                    <el-menu-item index="/option" >{{ $t("header.option") }}</el-menu-item>
                    <!-- ion -->
                    <el-menu-item index="/subscribe" v-if="configList.openSubscribe">{{ $t('subscribe.Su2') }}</el-menu-item>
                    <!-- 借币 -->
                    <el-menu-item index="/borrow/stepOne" v-if="configList.openLoan" >{{ $t('borrow.Bo1') }}</el-menu-item>
                    <!-- 法币 --> 
                    <!-- <el-menu-item index="/Purchase" v-if="configList.hasPay">{{ $t('Purchase.Pu1') }}</el-menu-item> -->
                    <!-- ion -->
                    <!-- <el-menu-item index="/lab">{{ $t("header.lab") }} </el-menu-item> -->
                    <!-- 推广合伙人 -->
                    <!-- <el-menu-item index="/invite">{{ $t("header.invite") }}</el-menu-item> -->
                    <!-- 公告 -->
                    <!-- <el-menu-item index="/announcement/0">{{ $t("header.service") }}</el-menu-item> -->
                    <el-submenu index="/Purchase" v-if="configList.hasPay">
                        <template slot="title"><span style="font-size: 12px;">{{ $t('Purchase.Pu1') }}</span>
                        </template>
                        <el-menu-item index="/ctwoc" v-if="getappLIst"> {{ `C2C${$t('nhome.Nu37')}` }}</el-menu-item>
                        <el-menu-item index="/Purchase">{{ $t('nhome.Nu36') }}</el-menu-item>
                    </el-submenu>
                    <!-- 法币 -->
                    <el-menu-item index="/Endirect" v-if="configList.hasLive">{{ $t("uc.safe.Ad5") }}</el-menu-item>
                </el-menu>
            </div>
        </el-col>

        <el-col :span="2" v-if="!isLogin">
            <div style="margin: 20px auto; color: #61688A;">
                <!-- <Link to="/login">
                <MenuItem name="1-1">{{ $t("common.login") }}</MenuItem>
                </Link>
                <Link to="/register">
                {{ $t("common.register") }}
                </Link> -->
                <span style=" cursor: pointer" @click="handleislogin('/login')">{{
            $t("common.login")
        }}</span>
                |<span style="margin-left: 5px; cursor: pointer" @click="handleislogin('/register')">{{
            $t("common.register")
        }}</span>
            </div>

        </el-col>
        <el-col :span="2" v-else><el-menu class="el-menu-demo" mode="horizontal" @select="handleSelect2"
                background-color="#172636" text-color="#61688A" active-text-color="none">
                <!-- 个人中心 -->
                <el-submenu index="/safe">
                    <template slot="title">{{ strpo(member.username) }}</template>
                    <!-- <el-menu-item index="/uc/money">
                        {{ $t("header.assetmanage") }}
                    </el-menu-item>
                    <el-menu-item index="/uc/entrust/current">{{ $t("header.trademanage") }}</el-menu-item>
                    <el-menu-item index="/uc/innovation/myorders">{{ $t("header.innovationmanage") }}</el-menu-item> -->
                    <el-menu-item index="/uc">{{ $t(" header.usercenter") }}</el-menu-item>
                    <el-menu-item index="6">{{ $t("common.logout") }}</el-menu-item>
                </el-submenu>
            </el-menu></el-col>
        <el-col :span="3">
            <div style="margin-top: 22px;">
                <div style="float: left; width: 60%;">
                    <span v-if="getappLIst" @click="changeCommon()"><img src="../assets/images/hatsApp1.png" alt=""
                            width="20" height="20"></span>

                    <i style="font-size: 21px; margin-right: 5%;" class="el-icon-download" @click=toclick()></i>
                    <el-dropdown trigger="hover" @command="onVisibleChange" class="dropdown">
                        <span class="el-dropdown-link">
                            <span style="color:#61688a;font-size: 16px;font-weight: 600;">{{
            $store.getters.usdtList.unitCode
        }}</span>
                        </span>
                        <el-dropdown-menu slot="dropdown" :hide-on-click="false">
                            <div class="drop">
                                <div style="width: 100%; ">
                                    <el-input v-model="input" @input="inputEvent" class="input" size="mini"
                                        prefix-icon="el-icon-search" :placeholder="$t('uc.finance.trade.search')"
                                        clearable style="width: 100%">
                                    </el-input>
                                </div>
                                <div style="height: 300px;overflow:auto ;">
                                    <el-dropdown-item v-for="item in exchangerateLists" :key="item.unitCode"
                                        :command="item.unitCode">{{ item.unitCode
                                        }}</el-dropdown-item>
                                </div>
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div style="float: right;  width: 40%;">
                    <!-- hatsApp -->
                    <el-dropdown @command="changelanguage">
                        <span class="el-dropdown-link">
                            <img src="../assets/images/gjh.png" alt="" width="24" height="24">{{ languageValues }}
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="item in languagslist" :key="item.apiValue"
                                :command="item.apiValue">{{
            item.name
        }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </el-col>

        <logins v-if="loginis" @loginisval="loginisvalc" :titles="loginTitle" />
        <el-dialog :close-on-click-modal='false' :title="`C2C${$t('nhome.Nu37')}`" :visible="dialogVisible"
            @close="closeDialog" width="30%">
            <div style="height: 80px; text-align:left">
                <div style="float: left;">{{ $t('nhome.Nu38') }}</div>
                <br>
                <div style="float: left;">{{ $t('nhome.Nu39') }}</div>
                <br>
                <div style="float: left;">{{ $t('nhome.Nu40') }}</div>
                <br>
            </div>
            <div slot="footer" style="text-align:center">
                <el-button type="primary" @click="changeCommon()">{{ $t('nhome.Nu41') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { languags, languags1 } from "@/config/constant";
import { querySystemWeb } from "@/api";
import { changeIcon } from "@/utils";
import logins from "../components/logins";
export default {
    name: "navmenu",
    components: { logins },
    data() {
        return {
            input: "",
            languags,
            languags1,
            logo: "../assets/images/logo-bottom.png",
            loginis: false,
            loginTitle: '1',
            exchangerateList: [],
            dialogVisible: false,
            getappLIst: '',
        };
    },
    created: function () {
        this.initialize();
        this.initView();
        this.getExchangerate()
        this.getapp()
    },
    computed: {

        exchangerateLists() {
            return this.exchangerateList.filter((item) => item["unitCode"].indexOf(this.input) == 0)
        },

        isLogin() {
            return this.$store.getters.isLogin;
        },
        activeIndex() {
            return this.$route.path
        },
        configList: function () {
            return this.$store.getters.configList;
        },
        member: function () {
            return this.$store.getters.member;
        },
        languageValues() {
            var curlang = this.$store.getters.lang;
            // var curlang = "en_US"
            this.$i18n.locale = curlang;

            return '';
        },
        languagslist() {
            return this.$store.getters.configList.languages
        },

        languageValue() {
            var curlang = this.$store.getters.lang;
            // var curlang = "en_US"
            this.$i18n.locale = curlang;
            if (curlang == "en_US") {
                return "English";
            }
            if (curlang == "ja_JP") {
                return "日本語";
            }
            if (curlang == "ko_KR") {
                return "한국어";
            }
            if (curlang == "de_DE") {
                return "Deutsche";
            }
            if (curlang == "fr_FR") {
                return "français";
            }
            if (curlang == "ru_RU") {
                return "Русский";
            }
            if (curlang == "it_IT") {
                return "italiano";
            }
            if (curlang == "es_ES") {
                return "Español";
            }
            if (curlang == "zh_HK") {
                return "繁體中文";
            }
            if (curlang == "zh_CN") {
                return "简体中文";
            }
            if (curlang == "en_IN") {
                return "हिंदी";
            }
            if (curlang == "it_CH") {
                return "Indonesia";
            }
            if (curlang == "pt_PT") {
                return "Portugal";
            }
            return curlang;
        },
    },
    methods: {
        getapp() {
            if (!this.isLogin) return;
            this.$http
                .post(this.host + '/uc/dapp/get/whatsapp',)
                .then((response) => {
                    var resp = response.body;
                    this.getappLIst = JSON.parse(resp.data).whatsapp

                });
        },
        changeCommon() {
            if (this.getappLIst) {
                window.open(this.getappLIst);
            }
            this.dialogVisible = false;
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        toclick() {
            window.open(this.$store.getters.configList.downloadLink)
        },
        inputEvent(val) {
            this.input = val.toUpperCase();
        },
        onVisibleChange(val) {
            this.$store.commit("setusdtLit", this.exchangerateList.filter((f) => f.unitCode == val)[0]);
            if (this.isLogin) {
                this.$http.get(this.host + "/uc/exchangerate/exchangeRateSetting" + `?memberId=${this.isLogin ? this.member.id : ''}&unitCode=${val}`).then((response) => {
                    var res = response.body;
                });
            }
        },
        getExchangerate() {
            this.$http.get(this.host + "/uc/exchangerate").then((response) => {
                var res = response.body;
                if (res.code == 0) {
                    this.exchangerateList = res.data
                }
            });
        },
        loginisvalc(val) {
            this.loginis = val
        },
        // '/uc/agent/system/system-web-query'
        initView() {
            this.$http.post(this.host + "/uc/agent/system/system-web-query", { realmName: location.origin }).then((response) => {
                var res = response.body;
                if (res.code == 0) {
                    // this.$store.commit("setAgentInfo", res.data);
                    // console.log('请求图片1', res);
                    if (res.data) {
                        // console.log('请求图片', res.data.logo || '');
                        // changeIcon(res.data?.logo);
                        // this.$store.commit("setLogo", res.data?.logo);
                        // this.logo = res.data?.logo
                    } else {
                        this.logo = '../assets/images/logo-bottom.png'
                    }
                    // document.title = res.data.website;
                }
            });
        },
        strpo(str) {
            if (str.length > 2) {
                str = str.slice(0, 2) + "··";
            } else {
                str = str;
            }
            return str;
        },
        handleislogin(val) {
            // this.loginTitle = val == '/login' ? '1' : '2'
            // this.loginis = true
            if (this.$route.path == val) return
            this.$router.push(val)
        },
        initialize() {
            this.$store.commit("navigate", "nav-index");
            this.$store.commit("recoveryMember");
            this.$store.commit("initLang");
            this.$store.commit("initLoginTimes");
            // this.$store.commit("initusdtLit");
            // this.checkLogin();
        },
        // 获取logo
        checkLogin() {
            this.$http.post(this.host + "/uc/check/login", {}).then((response) => {
                var result = response.body;
                if (result.code == 0 && result.data == false) {
                    this.$store.commit("setMember", null);
                }
            });
        },
        handleSelect(key, keyPath) {
            if (this.$route.path == key) return
            if (key == '/Endirect') {
                if (this.isLogin) {
                    window.open(`${this.configList.livePcUrl}/#/list?token=${localStorage.getItem('TOKEN')}&communicationKey=${this.member.communicationKey}&lang=${this.$store.getters.lang}`);
                } else {
                    this.$router.push("/login");
                }
            } else if (key == '/Purchase'||key == '/borrow/stepOne') {
                if (this.isLogin) {
                    this.$router.push(key);
                } else {
                    this.$router.push("/login");
                }
            } else if (key == '/ctwoc') {
                this.dialogVisible = true;

            } else {
                this.$router.replace(key).catch(err => { console.log(err) });
            }


        },
        handleSelect2(key, keyPath) {
            if (this.$route.path == key) return
            if (key == 6) {
                this.logout()
            } else {
                this.$router.push(key).catch(err => { console.log(err) });
            }
        },
        logout() {
            this.$store.commit("setusdtLit", {
                alias: "United States Dollar",
                createTime: 1709721002000,
                displaySymbol: "0024",
                exchangeRate: 1,
                status: 1,
                unitCode: "USD",
                updateTime: 1709721002000
            });
            this.$store.commit("setMember", null);
            localStorage.setItem("ISLOGINS", 0);
            this.$router.push("/");
            // localStorage.setItem("TOKEN", null);
            // this.$http.post(this.host + "/uc/loginout", {}).then((response) => {
            //     var resp = response.body;
            //     if (resp.code == 0) {
            //         this.$Message.success(resp.message);
            //         this.$store.commit("setMember", null);
            //         setTimeout(() => {
            //             this.$router.push("/");
            //         }, 1500);
            //     } else {
            //         this.$Message.error(resp.message);
            //     }
            // });
        },
        changelanguage(name) {
            console.log(name);
            this.$store.commit("setlang", name);
            this.$i18n.locale = name;
            // this.reload();
        },
    },
}
</script>
<style scoped>
/* .el-menu.el-menu--horizontal {
    border-bottom: none
} */

.header {
    height: 70px;
    width: 100%;
    background: #172636;
    font-size: 12px;

}

.layout-logo {
    margin-top: 12px
}

.menunav .el-dropdown-menu__item,
.el-menu-item {
    font-size: 12px;
    padding: 0 10px;
}

/* .el-submenu__title {
    padding: 0 10px;
    font-size: 12px;
} */
</style>



// WEBPACK FOOTER //
// src/components/NavMenu.vue